/* eslint-disable */
export default {
  logged: 'Logged',
  unlogged: 'Unworked',
  faxNotSupported: 'To-log fax is not supported.',
} as const;

// @key: @#@"logged"@#@ @source: @#@"Logged"@#@
// @key: @#@"unlogged"@#@ @source: @#@"Unworked"@#@
// @key: @#@"faxNotSupported"@#@ @source: @#@"To log fax is not supported."@#@
